<div class="main-container d-flex justify-content-center align-items-center" [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')'}">
    <div class="content-container">
        <div class="desktop-form-container">
            <div class="nav-header">
                <img src="assets/img/uniqode-header-logo-dark.png">
            </div>
            <div class="h-100 d-flex flex-column justify-content-center">
                <div class="form-title mb-2">Create your free card in minutes!</div>
                <div class="form-description mb-4">Enter your details to make a personalized digital business card.</div>
                <div class="form-body" id="scrollable-form-container">
                    <div class="desktop-form-body-container">
                        <div class="bx--row">
                            <div class="bx--col pr-2">
                                <div class="floating-input-box">
                                    <app-floating-label-input #nameInput [id]="'first_name'" type="email" [placeholder]="'Name*'" [model]="dbc.first_name" (modelChange)="inputChange($event, DBC_FORM_FIELD.FIRST_NAME)" [setErrorState]="isFirstNameMissing" [errorMessage]="'Required'"> </app-floating-label-input>
                                </div>
                            </div>
                            <div class="bx--col pl-2">
                                <div class="form-input-field d-flex pb-2">
                                    <app-floating-label-input #emailInput [id]="'email_v2'" type="email" [placeholder]="'Email*'" class="floating-label-input" (modelChange)="inputChange($event, DBC_FORM_FIELD.EMAIL)" [model]="dbc?.email_v2[0]?.value" [setErrorState]="isInvalidEmail" [errorMessage]="emailInputErrorMessage"> </app-floating-label-input>
                                </div>
                            </div>
                        </div>


                        <div class="bx--row">
                            <div class="bx--col-lg-8 bx--col-md-4 pr-2">
                                <div class="form-input-field intl-phone-input-desktop d-flex pb-2">
                                    <beaconstac-intl-tel-input *ngIf="fullPhoneNumber !== undefined && fullPhoneNumber !== null && countryNameCode"
                                                               [width]="'100%'" [disabled]="false"
                                                               [isRequired]="false"
                                                               [countryNameCode]="countryNameCode"
                                                               [value]="phoneNumber"
                                                               (countryChange)="onCountryChange($event)"
                                                               (phoneNumberChange)="inputChange($event, DBC_FORM_FIELD.PHONE_NUMBER)"
                                                               class="w-100">
                                    </beaconstac-intl-tel-input>
                                </div>
                            </div>
                            <div class="bx--col d-flex align-items-center pl-2" [@fadeIn] *ngIf="!expandedForm">
                                <div (click)="onAddMoreClick()" class="add-more-button pb-2 d-flex align-items-center justify-content-center">
                                    <img src="assets/img/dbc-onboard-v2/plus-circle.svg" alt="Add More Details" class="add-more-icon">
                                    Add More Details
                                </div>
                            </div>
                            <div class="bx--col pl-2" [@fadeIn] *ngIf="expandedForm">
                                <div class="floating-input-box">
                                    <app-floating-label-input #designationInput [id]="'designation'" type="text" [placeholder]="'Job title'" [model]="dbc.designation" (modelChange)="inputChange($event, DBC_FORM_FIELD.DESIGNATION)" ></app-floating-label-input>
                                </div>
                            </div>
                        </div>

                        <div class="bx--row" [@fadeIn] *ngIf="expandedForm">
                            <div class="bx--col pr-2">
                                <div class="floating-input-box">
                                    <app-floating-label-input #companyInput [id]="'company'" type="text" [placeholder]="'Company'" [model]="dbc.company" (modelChange)="inputChange($event, DBC_FORM_FIELD.COMPANY)"></app-floating-label-input>
                                </div>
                            </div>
                            <div class="bx--col pl-2">
                                <div class=" form-input-field d-flex mb-4">
                                    <app-floating-label-input #websiteInput [id]="'website_v2'" type="text" [placeholder]="'Website'" class="floating-label-input" (modelChange)="inputChange($event, DBC_FORM_FIELD.WEBSITE)" [model]="dbc?.website_v2[0]?.value"> </app-floating-label-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sticky-button-container">
                    <button *ngIf="!showSaveLoader" class="sticky-button" (click)="onSaveCard()">Save My Card</button>
                    <button *ngIf="showSaveLoader" class="sticky-button" [ngClass]="{'save-btn-clicked-state': showSaveLoader}"><spinner class="save-btn-spinner"></spinner></button>
                </div>
            </div>
        </div>

        <div class="preview-container d-flex flex-column justify-content-center align-items-center"
             [ngStyle]="{ 'background-color': previewBackgroundColor
            }">
            <input type="file" id="file-input-profile" style="display: none;" (change)="onFileSelected($event, IMAGE_TYPE.PROFILE)" />
            <input type="file" id="file-input-logo" style="display: none;" (change)="onFileSelected($event, IMAGE_TYPE.LOGO)" />

            <div class="flip-card-container" [class.flipped]="hasEdited">
                <!-- Image (Front) -->
                <img
                    class="enter-details-preview-img"
                    src="assets/img/dbc-onboard-v2/cards-onboard-preview.png"
                    (click)="onTextElementClick($event, DBC_FORM_FIELD.FIRST_NAME)"
                />

                <!-- Iframe (Back) -->
                <iframe
                    title="desktop-live-frame"
                    class="live-preview-iframe"
                    #digitalBusinessCardPreview
                ></iframe>
            </div>

            <!-- COLOR PICKER with Slide Up -->
            <div class="color-picker-wrapper" [ngClass]="!hasEdited ? 'd-none' : ''" [class.slide-up]="hasEdited">
                <app-color-picker-v2
                    (onColorChange)="inputChange($event, DBC_FORM_FIELD.BACKGROUND_COLOR)"
                    [colorOptions]="colorOptions"
                    [selectedColor]="layoutPrimaryColor"
                    [defaultColorPickerBackground]="defaultColorPickerBackground"
                    [labelText]="''"
                    id="background_color"
                    class="desktop-color-picker"
                ></app-color-picker-v2>
            </div>
        </div>
    </div>
</div>
